import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=56448038&scoped=true"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"
import style0 from "@vueform/multiselect/themes/default.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ProductFilter.vue?vue&type=style&index=1&id=56448038&prod&lang=scss"
import style2 from "./ProductFilter.vue?vue&type=style&index=2&id=56448038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56448038",
  null
  
)

export default component.exports